import request from '../../utils/request'
import { judgePermissions } from '@/utils/common.js'

const state = {}
const actions = {
    // 获取题目标签列表
    getQuestionTagList({dispatch}){
        return new Promise((resolve)=>{
            judgePermissions(['questionBank:tag:list']).then(res => {
                if (res) {
                    request({
                        url: `/api/question_bank/question/tag`,
                    }).then((data)=>{
                        resolve(data);
                    })
                }else {
                    resolve()
                }
            })
        })
    },

    // 获取题目标签组列表
    getQuestionTagGroupList({dispatch},data){
        return new Promise((resolve)=>{
            judgePermissions(['questionBank:tagGroup:list']).then(res => {
                if (res) {
                    request({
                        url: `/api/tag/group`,
                        params: {
                            tag_group_id: null,
                            tag_type: 'question'
                        }
                    }).then((data)=>{
                        resolve(data);
                    })
                }else {
                    resolve()
                }
            })
        })
    },

    // 创建题目标签组
    postQuestionTagGroup({dispatch},data){
        return new Promise((resolve)=>{
            request({
                url: `/api/question_bank/question/tag/group`,
                method: "post",
                data: {
                    tag_group_name: data.tag_group_name,
                    tag_name: data.tag_name
                }
            }).then((data)=>{
                resolve(data);
            })
        })
    },

    // 编辑题目标签组
    putQuestionTagGroup({dispatch},data){
        return new Promise((resolve)=>{
            request({
                url: `/api/question_bank/question/tag/group`,
                method: "put",
                data: {
                    tag_group_name: data.tag_group_name,
                    tag_group_id: data.tag_group_id
                }
            }).then((data)=>{
                resolve(data);
            })
        })
    },

    // 批量设置题目标签所属标签组
    batchPutQuestionTagGroup({dispatch},data){
        return new Promise((resolve)=>{
            request({
                url: `/api/question_bank/question/tag/update_group`,
                method: "put",
                data: {
                    tag_group_id: data.tag_group_id,
                    tag_id: data.tag_id
                }
            }).then((data)=>{
                resolve(data);
            })
        })
    },

    // 题目标签名称查重
    postQuestionTagValidation({dispatch},data){
        return new Promise((resolve)=>{
            request({
                url: `/api/question_bank/question/tag/validation`,
                method: "post",
                data: {
                    tag_name: data,
                }
            }).then((data)=>{
                resolve(data);
            })
        })
    },

    // 创建题目标签
    postQuestionTag({dispatch},data){
        return new Promise((resolve)=>{
            request({
                url: `/api/question_bank/question/tag`,
                method: "post",
                data: {
                    tag_group_id: data.tag_group_id,
                    tag_name: data.tag_name,
                }
            }).then((data)=>{
                resolve(data);
            })
        })
    },

    // 编辑题目标签
    putQuestionTag({dispatch},data){
        return new Promise((resolve)=>{
            request({
                url: `/api/question_bank/question/tag`,
                method: "put",
                data: {
                    tag_id: data.tag_id,
                    tag_group_id: data.tag_group_id,
                    tag_name: data.tag_name,
                }
            }).then((data)=>{
                resolve(data);
            })
        })
    },

    // 删除题目标签组
    deleteQuestionTagGroup({dispatch},data){
        return new Promise((resolve)=>{
            request({
                url: `/api/question_bank/question/tag/group`,
                method: "delete",
                data: { tag_delete_mode: data.range, tag_group_id: data.group_id }
            }).then((data)=>{
                resolve(data);
            })
        })
    },

    // 删除题目标签
    deleteQuestionTag({dispatch},data){
        return new Promise((resolve)=>{
            request({
                url: `/api/question_bank/question/tag`,
                method: "delete",
                data: { tag_id: data }
            }).then((data)=>{
                resolve(data);
            })
        })
    },
}

export default {
    state,
    actions
}